<template>
    <div class="layer-node-container" :data-exec-mode="execMode">

        <!-- Modo visualização -->
        <template v-if="execMode == gConsts.rt.execModes.VIEW">
            <div class="layer-node-header">
                <span class="layer-node-title">{{ node.report.text || node.layout.caption }}</span>
            </div>
            <div class="layer-node-content">
                <section class="layer-node-children">
                    <labelNodeSearch v-for="(child, index) in filteredChildren.label" 
                        :key="child.id" :node="child" :execMode="execMode"
                        :reportNode="childrenReportNodes[index]" 
                        :id="child.id" :active="activeNode ? activeNode?.label == child.id : false">
                    </labelNodeSearch>
                </section>
            </div>
        </template>

        <!-- Modo de edição (WORK) -->
        <template v-if="execMode == gConsts.rt.execModes.WORK">
            <expansionPanelUI @onExpandedChange="toggleActive" :expanded="isExpansionPanelExpanded" class="layer-node-expansion-panel" borderRadius="8">
                <template #header>
                    <div class="layer-node-header">
                        <span class="layer-node-title">{{ node.layout.caption }}</span>
                    </div>
                </template>
                <template #content>

                    <section class="layer-node-children" v-show="filteredChildren.label.length > 0">
                        <labelNodeSearch v-for="(child, index) in filteredChildren.label" 
                            :key="child.id" :node="child" :execMode="execMode"
                            :reportNode="childrenReportNodes[index]" :searchValue="searchValue"
                            :id="child.id" :active="activeNode ? activeNode?.label == child.id : false" :searchMode="searchMode">
                        </labelNodeSearch>
                    </section>
                </template>
            </expansionPanelUI>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import expansionPanelUI from '@/components/ui/expansionPanel.vue';
import labelNodeSearch from './labelNodeSearch.vue';
import _ from 'lodash';

import { gConsts } from '@/globals/gConsts';
import { evtBus } from '@/main';
import { reportUtils } from '@/features/report/lib/reportUtils';

export default {
    name: 'layerNodeSearch',
    components: {
        expansionPanelUI,
        labelNodeSearch
    },
    props: {
        execMode: {
            type: String,
            default: gConsts.rt.execModes.WORK
        },
        node: {
            type: Object,
            required: true
        },
        id: {
            type: String,
            required: true
        },
        activeNode: {
            type: Object,
            default: null
        },
        searchMode: {
            type: Boolean,
            default: false
        },
        searchValue: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            gConsts: gConsts,
            isActive: this.activeNode != null,
            filteredChildren: {
                label: []
            }
        }
    },

    methods: {
        toggleActive() {
            this.isActive = !this.isActive;

            evtBus.$emit('evt_relatorioDinamico_activateNode', { nodeId: this.id, nodeType: gConsts.node.layout.types.LAYER });
        },

        updateFilteredChildren(searchValue) {
            if (!searchValue.trim()) {
                this.filteredChildren.label = this.children;
                return
            }
            this.filteredChildren.label = this.children.filter(child => reportUtils.labelSearchForReportMatches(child, searchValue));
        },
    },

    watch: {
        activeNode(newVal) {
            this.isActive = newVal != null;
        },
        searchValue: {
            handler(newVal) {
            if (this.$updateFilteredChildren)
                this.$updateFilteredChildren(newVal);
            },
            immediate: true
        }
    },

    computed: {
        ...mapGetters([
            'GET_filteredNodes',
            'GET_reportNodes'
        ]),

        isExpansionPanelExpanded() {
            return this.isActive || this.searchValue.trim().length > 0;
        },

        children() { 
            return this.GET_filteredNodes.filter(node => node.layout.parent === this.node.id);
        },

        childrenReportNodes() {
            return this.filteredChildren.label.map(child => this.GET_reportNodes.find(reportNode => reportNode.id === child.id));
        }
    },

    mounted() {
        this.$updateFilteredChildren = _.debounce(this.updateFilteredChildren, 150);

        this.updateFilteredChildren(this.searchValue);
    }
}
</script>

<style scoped>

/* Modo visualização */

.layer-node-container[data-exec-mode="view"] {
    padding: var(--spacing-sm) var(--spacing);
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
}

.layer-node-container[data-exec-mode="view"] .layer-node-title {
    color: var(--color-black);
    letter-spacing: 0.5px;
}

.layer-node-container[data-exec-mode="view"] .layer-node-children {
    gap: 0;
}


/* Modo de edição (WORK) */

.layer-node-expansion-panel > :deep(.expansion-panel-header) {
    padding: var(--spacing-xs);
}

.layer-node-expansion-panel > :deep(.expansion-panel-header):hover {
    opacity: 0.7;
}

.layer-node-expansion-panel :deep(.expansion-panel-content) {
    padding: var(--spacing-sm) 0px;
}

.layer-node-expansion-panel :deep(.expansion-panel-header), .layer-node-expansion-panel :deep(.expansion-panel-content) {
    border: none !important;
    background: transparent !important;
}

.layer-node-header {
    display: flex;
    align-items: center;
    gap: var(--spacing);
    width: 100%;
}

.expansion-panel-header[data-expanded="true"] .layer-node-title {
    color: var(--color-primary);
}

.layer-node-title {
    font-family: var(--font-family-primary);
    font-weight: 600;
    font-size: var(--text-md);
    color: var(--color-secondary);
}

.layer-node-children {
    display: flex;
    flex-direction: column;
}
</style>